<template>
  <div class="wrap">
    <JNav :title="$t('VIP特权')">
      <!-- <template #right>
        <div class="right_rule">
          {{ $t('规则') }}
        </div>
      </template> -->
    </JNav>
    <div class="cont">
      <div class="member_level">
        <div class="level_info">
          <div class="level_img">
            <img :src="userInfo.rank_picture" alt="">
          </div>
          {{ userInfo.rank_title }}
        </div>
        <div class="level_btn" @click="show = true">
          <span>{{ $t('查看所有VIP权益') }}</span>
          <van-icon name="share" color="#434851" size="15" />
        </div>
      </div>
      <div class="info_item">
        <!-- <div class="item_title">{{ $t('总存款') }}</div> -->
        <div class="info">
          <div class="info_left">
            <div class="money">{{ $money(userInfo.money_plus) }} <span>/ {{ userInfo.rank_value }}</span></div>
            <div class="progress">
              <span>{{ userInfo.rank_title }}</span>&nbsp;
              <div class="line" :style="{
                '--width': (Number(userInfo.money_plus) / Number(userInfo.rank_value) * 100).toFixed(2) > 100
                  ? '100%' :
                  (Number(userInfo.money_plus) / Number(userInfo.rank_value) * 100).toFixed(2) + '%'
              }"></div>
              {{ (Number(userInfo.money_plus) / Number(userInfo.rank_value) * 100).toFixed(2) }}% <span>&nbsp;{{ userInfo.rank_last.title }}</span>
            </div>
          </div>
          <div class="btn" @click="RechargeEvent">{{ $t('go') }}</div>
        </div>
      </div>
      <div class="member_title">
        {{ $t('升级要求') }}
      </div>
      <div class="member_subtitle">{{ $t('满足条件') }}</div>
      <div class="rank_list">
        <div class="rank_list_item">
          <div class="item_name"></div>
          <div class="item_info">
            <div class="" style="text-align:center">{{ $t('单笔最大充值') }}</div>
          </div>
          <!-- <div class="item_info">
            <div class="">{{ $t('每月投注') }}</div>
          </div> -->
        </div>
        <div class="lists" :style="{ '--active': active }">
          <div class="list_item"></div>
          <div class="list_item" v-for="item, index in rankList" :key="index" :class="active == index ? '_active' : ''"
            @click="active = index">
            <div class="item_name">
              <img :src="$img(item.picture)" alt="">
              <div class="name_title">{{ item.title }}</div>
            </div>
            <div class="item_info">
              <div class="item_top">{{ userInfo.money_plus }}</div>
              <div class="item_mid">{{ `<` }}{{ item.value }}</div>
              <div class="item_bottom">{{ (Number(userInfo.money_plus) / Number(item.value) * 100).toFixed(2) > 1
                ? '100' :
                (Number(userInfo.money_plus) / Number(item.value) * 100).toFixed(2) }}%</div>
            </div>
          </div>
        </div>
      </div>
      <div class="note">
        <div class="note_title">{{ $t('newAdd.Note') }}</div>
        <div class="note_desc">
          <div class="desc">{{ $t('checkIn_0') }}</div>
          <div class="desc">{{ $t('checkIn_1') }}</div>
          <div class="desc">{{ $t('checkIn_2') }}</div>
          <div class="desc">{{ $t('checkIn_3') }}</div>
        </div>
      </div>
    </div>
    <van-overlay :show="show" @click="show = false">
      <div class="overlay" @click.stop>
        <div class="overlay_cont">
          <div class="cont_top">
            <div class="left">
              <div class="title">{{ rankList[active]?.title }}</div>
              <!-- <div class="subtitle">{{ $t('满足条件') }}</div> -->
            </div>
            <div class="right">
              <img :src="userInfo.rank_picture" alt="">
            </div>
          </div>
          <div class="cont_info">
            <div class="info_item">
              <div class="rule" v-html="rankList[active]?.desc"></div>
            </div>
          </div>
        </div>
        <div class="close">
          <van-icon @click="show = false" name="clear" color="#f2f2f2" size="23" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import JNav from "@/components/JNav";
import { USERS_RANKS } from "@/api"
import { Toast, Icon, Overlay } from "vant"
export default {
  components: {
    JNav,
    Toast,
    [Icon.name]: Icon,
    [Overlay.name]: Overlay
  },
  data() {
    return {
      userInfo: {},
      rankList: [],
      active: 0,
      show: false
    }
  },
  created() {
    this.getRank();
  },
  methods: {
    RechargeEvent() {
      this.$router.push("/new-recharge");
    },
    onChange(index) {
      this.active = index;
    },
    async getRank() {
      try {
        const res = await USERS_RANKS();
        this.rankList = res.data
        this.$nextTick(() => {
          this.getUserInfo();
        })
      } catch (error) { }
    },
    getUserInfo() {
      Toast.loading();
      this.$api.getUserInfo((res) => {
        Toast.clear();
        this.userInfo = res;
        const rankIndex = this.rankList.findIndex(item => item.title == res.rank_title)
        this.active = rankIndex < 0 ? 0 : rankIndex;
        window.document.getElementsByClassName('lists')[0].scrollLeft = this.active * 115;
      }, (err) => {
        Toast.clear();
      });
    },
  }
}
</script>
<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  background: #f5f5f9;

  .right_rule {
    color: var(--light);
  }

  .cont {
    padding: calc(10rem / 16) calc(15rem / 16);

    .member_level {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: calc(60rem / 16);
      border-radius: calc(10rem / 16);
      background: linear-gradient(0deg, #f1f9ff, #b3bcc8);
      gap: calc(8rem / 16);

      &::before {
        position: absolute;
        content: "";
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: url(../../../assets/new/mine/level_info_bg.png) no-repeat 50% / cover;
        z-index: 0;
      }

      .level_info {
        display: flex;
        align-items: center;
        position: relative;
        z-index: 1;

        .level_img {
          margin: calc(-4rem / 16) calc(12rem / 16) 0;

          img {
            height: calc(68rem / 16);
            display: block;
          }
        }

        color: #333;
        font-size: calc(22rem / 16);
        font-weight: 800;
      }

      .level_btn {
        position: relative;
        z-index: 1;
        border-radius: 35px 0 0 35px;
        background: hsla(0, 0%, 100%, .4);
        box-shadow: -1.5px 4.5px 10px 0 rgba(0, 0, 0, .1);
        -webkit-backdrop-filter: blur(1px);
        backdrop-filter: blur(1px);
        width: 80px;
        min-height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
        padding: 0 7.5px 0 12px;
        color: #434851;

        span {
          font-size: calc(10rem / 16);
          font-weight: 600;
          line-height: 1;
          word-break: break-word;
        }
      }
    }

    .info_item {
      padding-top: calc(10rem / 16);

      .item_title {
        color: #a6a6a6;
        font-size: calc(12rem / 16);
        font-weight: 600;
      }

      .info {
        display: flex;
        align-content: center;
        margin-top: calc(10rem / 16);
        gap: 10px;

        .info_left {
          flex: 1;

          .money {
            color: #656565;
            font-size: calc(14rem / 16);
            font-weight: bold;

            span {
              font-weight: 400;
              font-size: calc(12rem / 16);
            }
          }

          .progress {
            display: flex;
            align-items: center;

            .line {
              flex: 1;
              height: 8px;
              border-radius: 40px;
              background: #b5b5b5b3;
              margin-right: 10px;
              position: relative;
              overflow: hidden;

              &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                right: 0;
                width: var(--width);
                bottom: 0;
                background: var(--bg);
                border-radius: 10px;
              }
            }

            font-size: calc(11rem / 16);
            color: #a6a39d;
            span{
              color: #656565;
              // font-weight: bold;
              font-size: calc(14rem / 16);
            }
          }
        }

        .btn {
          background: #333;
          border-radius: 100px;
          font-size: calc(10rem / 16);
          font-weight: 600;
          color: var(--light);
          padding: 0 2px;
          text-align: center;
          height: 27px;
          line-height: 27px;
          min-width: calc(54rem / 16);
        }
      }
    }

    .member_title {
      margin: calc(20rem / 16) 0 calc(12rem / 16);
      color: #666;
      font-size: calc(14rem / 16);
      font-weight: 600;
      border-left: 5px solid #fd2f2f;
      padding-left: calc(20rem / 16);
    }

    .member_subtitle {
      color: #666;
      font-size: calc(11rem / 16);
    }

    .rank_list {
      border-radius: calc(10rem / 16);
      margin-top: calc(10rem / 16);
      position: relative;
      background-color: var(--light);
      box-shadow: rgba(29, 189, 201, 0.3) 0px 0px 20px 0px;
      display: flex;
      flex-wrap: nowrap;

      .rank_list_item {
        background: linear-gradient(180deg, rgba(241, 249, 255, .15), rgba(179, 188, 200, .15));
        color: #666;
        font-size: calc(12rem / 16);
        position: absolute;
        z-index: 1;
        left: 0;
        font-weight: 600;
        width: 115px !important;

        .item_name {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: calc(6rem / 16) 0;
          height: calc(40rem / 16);
          gap: calc(10rem / 16);
        }

        .item_info {
          display: flex;
          flex-direction: column;
          height: calc(97rem / 16);
          padding: calc(11rem / 16) calc(4rem / 16);
          border-bottom: 1px solid hsla(240, 7%, 94%, .5);
        }
      }

      .lists {
        display: flex;
        flex-wrap: nowrap;
        overflow-x: scroll;
        // padding-left: 115px;

        &::-webkit-scrollbar {
          display: none;
        }

        // /deep/ .van-swipe{
        //   overflow: unset;
        // }
      }

      .list_item {
        min-width: 115px;
        max-width: 115px;
        display: flex;
        flex-direction: column;
        border-left: 1px solid hsla(240, 7%, 94%, .5);

        .item_name {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: calc(6rem / 16) 0;
          height: calc(40rem / 16);
          gap: calc(10rem / 16);
          border-bottom: 1px solid hsla(240, 7%, 94%, .5);

          img {
            height: calc(28rem / 16);
            object-fit: contain;
          }

          .name_title {
            font-size: 11px;
            color: #e4e4e4;
            font-weight: 700;
          }
        }

        .item_info {
          display: flex;
          flex-direction: column;
          height: calc(97rem / 16);
          padding: calc(11rem / 16) calc(4rem / 16);
          // border-bottom: 1px solid hsla(240, 7%, 94%, .5);

          .item_top {
            font-size: calc(12rem / 16);
            font-weight: 700;
            color: #e4e4e4;
          }

          .item_mid {
            margin-top: 2px;
            color: #e4e4e4;
            font-size: calc(10rem / 16);
            font-weight: 600;
            text-align: right;
          }

          .item_bottom {
            flex-grow: 1;
            display: flex;
            justify-content: flex-end;
            align-items: flex-end;
            text-align: right;
            color: rgba(0, 0, 0, .5);
            font-size: calc(12rem / 16);
            font-weight: 700;
          }
        }
      }

      ._active {
        .item_name {
          .name_title {
            color: #000;
          }
        }

        .item_info {

          .item_top,
          .item_mid {
            color: #979797;
          }
        }
      }
    }

    .note {
      .note_title {
        font-size: calc(14rem / 16);
        color: #333;
        margin-top: calc(16rem / 16);
      }

      .note_desc {
        padding: calc(8rem / 16) 0;

        .desc {
          font-size: calc(14rem / 16);
          color: #333;
          line-height: 1.2;
        }
      }
    }
  }

  /deep/ .van-overlay {
    display: flex;
    align-items: flex-end;
    justify-content: center;

    .overlay {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .overlay_cont {
        width: 80vw;
        background-color: var(--light);
        border-radius: 10px;

        .cont_top {
          min-height: calc(60rem / 16);
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 calc(12rem / 16) 0 calc(20rem / 16);
          gap: calc(17rem / 16);

          .left {
            display: flex;
            flex-direction: column;
            gap: calc(6rem / 16);
            color: #333;
            font-size: calc(16rem / 16);
            font-weight: 700;

            .title {
              font-size: calc(22rem / 16);
              color: var(--textColor);
            }

            .subtitle {
              font-size: calc(12rem / 16);
              font-weight: 500;
            }
          }

          .right {
            margin: calc(-4rem / 16) calc(12rem / 16) 0;

            img {
              height: calc(68rem / 16);
              display: block;
            }
          }

        }

        .cont_info {
          padding: calc(15rem / 16) calc(10rem / 16);

          .info_item {
            padding: 0 calc(10rem / 16);

            .rule {
              white-space: pre-line;
              color: #333;
              font-size: calc(14rem / 16);
            }
          }
        }
      }

      .close {
        padding: calc(10rem / 16);
        text-align: center;
        width: fit-content;
      }
    }
  }
}
</style>